import type useAppStore from '@content-selector/stores/app'
import type useApiStore from '@content-selector/stores/api'
import { inject } from 'vue'

export function useStore() {
  return inject('contentSelectorStore') as ReturnType<typeof useAppStore>
}

export function useStoreApi() {
  return inject('contentSelectorApiStore') as ReturnType<typeof useApiStore>
}
